<template>
  <div class="collapsable">
    <div
      class="collapsable__header"
      @click="() => (isCollapsed = !isCollapsed)"
    >
      <slot name="persistant" />

      <v-button ghost icon class="ml-auto collapsable__toggle p-2">
        <v-icon v-if="isCollapsed" icon="keyboard_arrow_down" />
        <v-icon v-else icon="keyboard_arrow_up" />
      </v-button>
    </div>

    <div v-show="!isCollapsed" class="collapsable__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    collapsed: { type: Boolean, default: true }
  },

  data() {
    return {
      isCollapsed: this.collapsed
    }
  }
}
</script>

<style lang="scss">
.collapsable__header {
  display: flex;
  align-items: flex-start;
}

.collapsable__toggle {
  flex-shrink: 0;
}
</style>
